import { SearchOutlined } from '@ant-design/icons'
import { Button, DatePicker, Select, Tooltip } from 'antd'
import moment from 'moment'
import React from 'react'
import { useSelector } from 'react-redux'
import { useMediaQuery } from 'react-responsive'
import styled from 'styled-components'
import { translate } from '../../../../languages'
import { RootState } from '../../../../stores'

const StyledFilter = styled.div<{
  style: {
    isDesktopScreen: boolean
  }
}>`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: start;
  margin-bottom: 10px;
`

const StyledFilterItem = styled.div`
  width: 100%;
  margin: 10px 15px 0 0;
  min-width: 300px;
  max-width: 350px;
  display: flex;
`

const StyledFilterItemTitle = styled.div`
  font-weight: bold;
  margin-right: 5px;
  margin-top: 2.5px;
`

type StatisticFilterComponentProps = {
  rangeValue: {
    startTime: number
    endTime: number
  }
  selectedStationIds?: number[]
  onRangePickerChange: (e: any) => void
  onSelectStationChange: (e: any) => void
  onSearch: () => void
}

export const StatisticFilterComponent: React.FC<StatisticFilterComponentProps> =
  ({
    rangeValue,
    selectedStationIds,
    onRangePickerChange,
    onSelectStationChange,
    onSearch,
  }) => {
    const { stations, isStationsLoaded } = useSelector(
      (state: RootState) => state.station
    )
    const { language } = useSelector((state: RootState) => state.language)

    const isDesktopScreen = useMediaQuery({ minWidth: '1300px' })

    return (
      <StyledFilter style={{ isDesktopScreen }}>
        <StyledFilterItem>
          <StyledFilterItemTitle>
            {translate('dashboard.filter.time', language)}
          </StyledFilterItemTitle>
          <DatePicker.RangePicker
            format="DD/MM/YYYY"
            placeholder={[
              translate('dashboard.filter.time.from', language),
              translate('dashboard.filter.time.to', language),
            ]}
            value={[moment(rangeValue.startTime), moment(rangeValue.endTime)]}
            onChange={(e) => onRangePickerChange(e)}
          />
        </StyledFilterItem>
        <StyledFilterItem>
          <StyledFilterItemTitle>
            {translate('dashboard.filter.station', language)}
          </StyledFilterItemTitle>
          <Select
            placeholder={translate('dashboard.filter.station', language)}
            loading={!isStationsLoaded}
            disabled={!isStationsLoaded}
            mode="multiple"
            maxTagCount="responsive"
            value={selectedStationIds}
            style={{ width: '100%' }}
            onChange={(e) => onSelectStationChange(e)}
          >
            {stations.map((item) => (
              <Select.Option
                value={item.id}
                key={item.id}
              >{`${item.name} (${item.owner.name})`}</Select.Option>
            ))}
          </Select>
        </StyledFilterItem>
        <Tooltip title={translate('common.search', language)}>
          <Button
            type="primary"
            icon={<SearchOutlined />}
            style={{ marginTop: '10px' }}
            onClick={onSearch}
          >
            {translate('common.search', language)}
          </Button>
        </Tooltip>
      </StyledFilter>
    )
  }
